module.exports = __webpack_public_path__ + "img/app.934590fb.svg";